import { useNavigate } from 'react-router';
import { Button } from '@staff-app/ui';
import { useAuthStore } from '@/stores/auth-store';

/**
 * Shown when a signed-in staff user hits a section their role can't access —
 * e.g. a `member` navigating to /staff/customers by URL. The backend
 * AdminRoleGuard would 403 the underlying queries anyway; this is the friendly
 * UX layer (route-level), distinct from PendingApprovalPage (no admin_users
 * row / disabled).
 */
export function NotAuthorizedPage() {
  const navigate = useNavigate();
  const email = useAuthStore((s) => s.adminUser?.email);

  return (
    <div
      className="flex min-h-screen items-center justify-center bg-muted px-4"
      data-testid="not-authorized-page"
    >
      <div className="w-full max-w-md rounded-lg border bg-card p-8 text-center shadow-sm">
        <h1 className="text-xl font-semibold text-foreground">{'Not authorized'}</h1>
        <p className="mt-3 text-sm text-muted-foreground">
          {
            "You don't have access to this section. Ask a root admin to upgrade your role if you need it."
          }
        </p>
        {email ? (
          <p className="mt-4 rounded-md bg-muted px-3 py-2 text-sm font-medium text-foreground">
            {email}
          </p>
        ) : null}
        <Button
          variant="outline"
          className="mt-6 w-full"
          onClick={() => navigate('/staff/enroll')}
          data-testid="not-authorized-back"
        >
          {'Go to Enroll my laptop'}
        </Button>
      </div>
    </div>
  );
}
